$(document).ready(function () {
  $(".nav-img-col").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      "<img class='prev ars-prv slick-prev' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_2.png?v=1729863606'>",
    nextArrow:
      "<img class='next ars-nxt slick-next' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_1.png?v=1729863606'>",
    fade: true,
    asNavFor: ".nav-content-col",
  });

  $(".nav-content-col").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".nav-img-col",
    dots: false,
    vertical: false,
    centerMode: false,
    arrows: true,
    prevArrow:
      "<img class='prev ars-prv slick-prev' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_2.png?v=1729863606'>",
    nextArrow:
      "<img class='next ars-nxt slick-next' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_1.png?v=1729863606'>",
    fade: true,
    focusOnSelect: true,
  });

  $(".nav-img-col").on("beforeChange", function (event, slick, currentSlide) {
    $(".right-nav-top-main")
      .css({ top: "20px", opacity: 0 })
      .animate({ top: "0px", opacity: 1 }, 500);
  });
  $(".mak_slide_scroll").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow:
      "<img class='prev ars-prv1 slick-prev' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_2.png?v=1729863606'>",
    nextArrow:
      "<img class='next ars-nxt1 slick-next' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_1.png?v=1729863606'>",
  });
  $(".mak-video-slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow:
      "<img class='prev ars-prv1 slick-prev' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_2.png?v=1729863606'>",
    nextArrow:
      "<img class='next ars-nxt1 slick-next' src='https://cdn.shopify.com/s/files/1/0803/8468/8473/files/Arrow_1.png?v=1729863606'>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          infinite: false,
        },
      },
    ],
  });
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".plyr_cover").forEach(function (cover) {
    cover.addEventListener("click", function () {
      const video = this.previousElementSibling.querySelector("video");
      if (video.paused) {
        video.play();
        this.style.opacity = "0";
      } else {
        video.pause();
        this.style.opacity = "1";
      }
    });
  });
});
// $(document).ready(function() {
//     // Function to get the variant ID from the URL
//     function getVariantIdFromUrl() {
//         var currentUrl = window.location.href;
//         var variantId = currentUrl.split("variant=")[1];
//         return variantId;
//     }

//     // Update price for the one-time purchase option
//     function updateOneTimePrice() {
//         const element = $('.loop-one-time-purchase-option');
//         if (element.hasClass('loop-selected-selling-plan-group')) {
//             const oneTimePriceText = $('.loop-one-time-purchase-option-price-amount')
//                 .text()
//                 .replace(/[^0-9.-]+/g, '');
//             const oneTimePrice = parseFloat(oneTimePriceText);
//             const currencySymbol = $('body').data('currency-symbol') || '$';

//             if (!isNaN(oneTimePrice)) {
//                 $('.price-item--sale').text(currencySymbol + oneTimePrice.toFixed(2));
//                 console.log("One-time Price Updated:", currencySymbol + oneTimePrice.toFixed(2));
//             } else {
//                 console.error("Invalid one-time price.");
//             }
//         }
//     }

//     // Update price for the subscription plan option
//     function updateSubscriptionPrice() {
//         const element = $('.loop-full-width.loop-subscription-group');
//         if (element.hasClass('loop-selected-selling-plan-group')) {
//             const subscribePriceText = $('.loop-subscription-group-price-amount')
//                 .text()
//                 .replace(/[^0-9.-]+/g, '');
//             const subscribePrice = parseFloat(subscribePriceText);
//             const currencySymbol = $('body').data('currency-symbol') || '$';

//             if (!isNaN(subscribePrice)) {
//                 $('.price-item--sale').text(currencySymbol + subscribePrice.toFixed(2));
//                 console.log("Subscription Price Updated:", currencySymbol + subscribePrice.toFixed(2));
//             } else {
//                 console.error("Invalid subscription price.");
//             }
//         }
//     }

//     // Initialize price update on page load
//     function initializePriceUpdate() {
//         console.log("Initializing Price Update...");
//         setTimeout(function() {
//             updateOneTimePrice();
//             updateSubscriptionPrice();
//         }, 500);
//     }
//     initializePriceUpdate();

//     // Update prices on variant change
//     $(document).on('change', '.mak__change', function() {
//         setTimeout(function() {
//             updateOneTimePrice();
//             updateSubscriptionPrice();
//         }, 500);
//     });

//     // Update prices on one-time purchase option change
//     $(document).on('change', '.loop-one-time-purchase-option', function() {
//         setTimeout(updateOneTimePrice, 500);
//     });

//     // Update prices on subscription plan change
//     $(document).on('change', '.loop-subscription-group', function() {
//         setTimeout(updateSubscriptionPrice, 500);
//     });
// });

$(document).ready(function () {
  // Trigger logic whenever a radio button is changed
  $('input[name="mak-Size"]').on("change", function () {
    var checked_value = $('input[name="mak-Size"]:checked').val();
    console.log("Checked value after change:", checked_value);

    if (checked_value) {
      var containerSection = this.closest("section");
      var variant_selects =
        (containerSection &&
          containerSection.querySelector("variant-selects")) ||
        document.querySelector("variant-selects");
      if (!variant_selects) {
        console.warn("variant-selects element not found.");
        return;
      }

      // Prefer updating the select (if present)
      var size_select = variant_selects.querySelector(
        "select[name='options[Size]']"
      );
      if (size_select) {
        try {
          if (typeof Shopify !== "undefined" && Shopify.setSelectorByValue) {
            Shopify.setSelectorByValue(size_select, checked_value);
          } else {
            // Fallback: set value/index manually
            var matchedIndex = -1;
            for (var i = 0; i < size_select.options.length; i++) {
              var opt = size_select.options[i];
              if (opt.value === checked_value || opt.text === checked_value) {
                matchedIndex = i;
                break;
              }
            }
            if (matchedIndex >= 0) size_select.selectedIndex = matchedIndex;
          }
        } catch (e) {
          console.error("Failed to set select value:", e);
        }
        // Dispatch a bubbling change event so VariantSelects picks it up
        size_select.dispatchEvent(new Event("change", { bubbles: true }));
        console.log("Variant select updated via <select> to:", checked_value);
        return;
      }

      // Fallback: update radio inside variant-selects (button picker)
      // Be flexible: match radios whose name or fieldset legend mentions "Size"
      var allRadios = variant_selects.querySelectorAll("input[type='radio']");
      var radios = Array.prototype.filter.call(allRadios, function (input) {
        var nm = (input.getAttribute("name") || "").toLowerCase();
        var fs = input.closest("fieldset");
        var legendTxt = "";
        if (fs) {
          var lg = fs.querySelector("legend");
          legendTxt = lg ? (lg.textContent || "").toLowerCase() : "";
        }
        return nm.indexOf("size") !== -1 || legendTxt.indexOf("size") !== -1;
      });

      var targetRadio = null;
      for (var r = 0; r < radios.length; r++) {
        if (radios[r].value === checked_value && !radios[r].disabled) {
          targetRadio = radios[r];
          break;
        }
      }
      if (targetRadio) {
        targetRadio.checked = true;
        // Ensure UI handlers tied to click run, then ensure change bubbles for VariantSelects
        targetRadio.click();
        targetRadio.dispatchEvent(new Event("change", { bubbles: true }));
        console.log("Variant select updated via radio to:", checked_value);
      } else {
        console.warn("No matching radio found for:", checked_value);
      }
    } else {
      console.log("No radio button is selected or no value found.");
    }
  });

  // Initialize only for our custom mak radios: delay, then click the last enabled mak-Size in each section
  // This ensures we don't affect other pickers (e.g., dropdown-only sections)
  setTimeout(function () {
    try {
      var makSizeInputs = document.querySelectorAll(
        "input[type='radio'][name='mak-Size']"
      );
      if (!makSizeInputs.length) return;

      // Group by nearest section
      var groupBySection = {};
      for (var i = 0; i < makSizeInputs.length; i++) {
        var input = makSizeInputs[i];
        var section = input.closest("section");
        var key = section ? section.id : "__global__";
        if (!groupBySection[key])
          groupBySection[key] = { section: section, inputs: [] };
        groupBySection[key].inputs.push(input);
      }

      Object.keys(groupBySection).forEach(function (key) {
        var bucket = groupBySection[key];
        var inputs = bucket.inputs;
        for (var j = inputs.length - 1; j >= 0; j--) {
          var radio = inputs[j];
          if (radio.disabled) continue;
          if (!radio.checked) radio.checked = true;
          // Use click + change to drive our existing sync handler
          radio.click();
          $(radio).trigger("change");
          console.log(
            "Initialization (scoped): clicked last mak-Size radio:",
            radio.value
          );
          break;
        }
      });
    } catch (e) {
      console.warn("Initialization for mak radios failed:", e);
    }
  }, 1000);
});
